import React from 'react';
import './photocontainerr.css'


const Photocontainer = (props) => {
    return ( 
                                    <section className='img-container-story'>
                                        <article className='img-and-text-container-story'>
                                            <img src={props.img} alt={props.imgalt}></img>
                                            <h2 className='textt-story'>{props.title}</h2>
                                        </article>

                                    </section>
     );
}
 
export default Photocontainer;